import { render } from "./CounterpartyDetailsPage.vue?vue&type=template&id=2f64e838&scoped=true"
import script from "./CounterpartyDetailsPage.vue?vue&type=script&lang=js"
export * from "./CounterpartyDetailsPage.vue?vue&type=script&lang=js"

import "./CounterpartyDetailsPage.vue?vue&type=style&index=0&id=2f64e838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f64e838"]])

export default __exports__